import { render } from "./rename-modal.vue?vue&type=template&id=1c75492d&scoped=true&ts=true"
import script from "./rename-modal.vue?vue&type=script&lang=ts"
export * from "./rename-modal.vue?vue&type=script&lang=ts"

import "./rename-modal.vue?vue&type=style&index=0&id=1c75492d&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c75492d"]])

export default __exports__